import DropShadow from 'react-native-drop-shadow';
import styled from 'styled-components/native';

import IconNaviDown from '../../assets/svg/IconNaviDown';
import IconNavUp from '../../assets/svg/IconNavUp';
import { isApp } from '../../boot/utils';
import { neutralGrey } from '../../constants/color';
import NoScaleText from '../../elements/NoScaleText';
import Touchable from '../../elements/Touchable/';
import { useTranslation } from '../../i18n';

type Props = {
  isDetailCollapsed: boolean;
  onPress: () => void;
};

const ToggleSection = ({ isDetailCollapsed, onPress }: Props) => {
  const { t } = useTranslation();

  const toggleSectionText = isDetailCollapsed
    ? t('expand-details')
    : t('collapse-details');

  return (
    <S.Shadow>
      <S.ToggleSection onPress={onPress}>
        <S.ToggleSectionText>{toggleSectionText}</S.ToggleSectionText>
        <S.IconWrapper>
          {isDetailCollapsed ? (
            <IconNavUp size={16} fillColor={neutralGrey} />
          ) : (
            <IconNaviDown size={16} fillColor={neutralGrey} />
          )}
        </S.IconWrapper>
      </S.ToggleSection>
    </S.Shadow>
  );
};

const S = {
  Shadow: styled(DropShadow)`
    shadow-color: ${({ theme }) => theme.palette.neutralDark};
    shadow-opacity: 0.1;
    shadow-offset: 0 -3px;
    shadow-radius: 3px;
  `,
  ToggleSection: styled(Touchable)`
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    background-color: ${({ theme }) => theme.palette.white};
    border-radius: 1px;
    border-bottom-width: 1px;
    border-bottom-style: dashed;
    /* https://github.com/facebook/react-native/pull/29099
    App 單邊虛線樣式 issue 與 UED 討論後用淡色實線替代
     */
    border-bottom-color: ${({ theme }) =>
      isApp ? theme.palette.neutralWhite : theme.palette.neutralLight};
  `,
  ToggleSectionText: styled(NoScaleText)`
    font-size: 13px;
    margin-right: 2px;
    color: ${({ theme }) => theme.palette.neutralDark};
  `,
  IconWrapper: styled.View`
    margin-bottom: 2px;
  `,
};

export default ToggleSection;
